import React, { useContext } from "react";
import './toggle.css';
import Sun from '../../img/sun.png';
import Moon from '../../img/moon.png';
import { ThemeContext } from "../../context";

function Toggle() {
    const theme = useContext(ThemeContext);

    function handleClick() {
        theme.dispatch({ type: 'TOGGLE' })
    }

    return (
        <div className="t">
          <img src={ Sun } alt="sol" className="t-icon" />
          <img src={ Moon } alt="lua" className="t-icon" />
          <div onClick={ handleClick } style={ { left: theme.state.darkMode ? 0 : 25 } } className="t-button"></div>
        </div>
    )
}

export default Toggle;
